import { Component, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { AlertStatusLegendDialogComponent } from './alert-status-legend-dialog.component';

@Component({
  selector: 'app-alert-status-legend',
  standalone: true,
  template: `
    <div class="alert-status-legend-row">
      <button type="button" (click)="open()">Alert Status Legend</button>
    </div>
  `,
  styles: [
    `
      .alert-status-legend-row {
        display: flex;
        justify-content: flex-end;
        padding: 8px 16px 4px;
      }

      button {
        margin: 0;
        padding: 0;
        border: 0;
        background: none;
        color: var(--afas-purple);
        font-size: 0.875rem;
        line-height: 1.35;
        cursor: pointer;
        text-decoration: underline;
      }
    `,
  ],
})
export class AlertStatusLegendComponent {
  #dialog = inject(MatDialog);

  open(): void {
    this.#dialog.open(AlertStatusLegendDialogComponent, { width: '480px' });
  }
}
